// src/pages/NotFound.jsx
import React from "react";
import { Link } from "react-router-dom";

export default function NotFound() {
  return (
    <section className="flex flex-col items-center justify-center text-center min-h-[70vh] px-6 bg-white text-gray-800">
      {/* 에러 타이틀 */}
      <h1 className="text-6xl font-extrabold text-red-500 mb-4">404</h1>
      <h2 className="text-2xl font-semibold mb-4">
        We couldn't find the page you were looking for.
      </h2>

      {/* 안내문 */}
      <p className="text-gray-600 max-w-xl mb-8 leading-relaxed">
        This is either because there is an error in the URL entered into your
        browser, or the page you are looking for has been moved or deleted.
      </p>

      {/* 버튼 영역 */}
      <div className="flex gap-4">
        <Link
          to="/"
          className="px-6 py-3 bg-red-500 text-white rounded-lg hover:bg-red-600 transition-colors"
        >
          Go to Homepage
        </Link>
        <a
          href="/en/games"
          className="px-6 py-3 border border-gray-400 text-gray-700 rounded-lg hover:bg-gray-100 transition-colors"
          target="_blank"
          rel="noopener noreferrer"
        >
          Explore our games
        </a>
      </div>
    </section>
  );
}
